
const develop_cart_content = () => {
    const carte_soin = document.querySelectorAll(".carte-soin");
    if(carte_soin.length > 0){
      carte_soin.forEach(carte => {
        const btn = carte.querySelector("button span");
        btn.addEventListener("click", () => {
          carte.classList.toggle("show");
          if(carte.classList.contains("show")){
            btn.innerText = "Afficher moins";
          }else{
            btn.innerText = "Lire les détails";
          }
        })
      })
    }
};

export default develop_cart_content;